import { takeLatest } from "redux-saga/effects";
import { createAction } from "redux-smart-actions";
import { deleteSaga } from "src/request/delete";
import { getSaga } from "src/request/get";
import { postSaga } from "src/request/post";
import { putSaga } from "src/request/put";
import { SagaActionParams, SagaGenericParams } from "src/request/types";
import * as Type from "./type";

export const getExtraServiceListSaga = createAction(
  "GET_EXTRA_SERVICE",
  ({ payload, params }: SagaActionParams<Type.ExtraServiceDto[]>) => ({
    payload,
    url: "/api/admin/adminextraservice" + (params ? params : ""),
  })
);
export const getExtraServiceDetailsSaga = createAction(
  "GET_EXTRA_SERVICE_DETAILS",
  ({ payload, id }: SagaActionParams<Type.ExtraServiceDetailDto>) => ({
    payload,
    url: "/api/admin/adminextraservice/" + id,
  })
);
export const createExtraServiceSaga = createAction(
  "CREATE_EXTRA_SERVICE",
  ({ payload, body }: SagaActionParams<Type.ExtraServiceDto>) => ({
    payload,
    url: "/api/admin/adminextraservice",
    body,
  })
);
export const updateExtraServiceSaga = createAction(
  "UPDATE_EXTRA_SERVICE",
  ({ payload, id, body }: SagaActionParams<Type.ExtraServiceDto>) => ({
    payload,
    url: "/api/admin/adminextraservice/" + id,
    body,
  })
);
export const deleteExtraServiceSaga = createAction(
  "DELETE_EXTRA_SERVICE",
  ({ payload, id }: SagaActionParams<Type.ExtraServiceDto>) => ({
    payload,
    url: "/api/admin/adminextraservice/" + id,
  })
);

const extraServiceSaga = [
  takeLatest<any>(
    getExtraServiceListSaga.toString(),
    (payload: SagaGenericParams<Type.ExtraServiceDto[]>) =>
      getSaga<Type.ExtraServiceDto[]>(payload)
  ),
  takeLatest<any>(
    getExtraServiceDetailsSaga.toString(),
    (payload: SagaGenericParams<Type.ExtraServiceDetailDto>) =>
      getSaga<Type.ExtraServiceDetailDto>(payload)
  ),
  takeLatest<any>(
    createExtraServiceSaga.toString(),
    (payload: SagaGenericParams<Type.ExtraServiceDto>) =>
      postSaga<Type.ExtraServiceDto>(payload)
  ),
  takeLatest<any>(
    updateExtraServiceSaga.toString(),
    (payload: SagaGenericParams<Type.ExtraServiceDto>) =>
      putSaga<Type.ExtraServiceDto>(payload)
  ),
  takeLatest<any>(
    deleteExtraServiceSaga.toString(),
    (payload: SagaGenericParams<any>) =>
      deleteSaga<Type.ExtraServiceDto>(payload)
  ),
];

export default extraServiceSaga;
